import angular from 'angular';
import billfoldModule from './billfold/billfold';
import reportOrdersModule from './orders/orders';

let reportsModule = angular.module('app.reports', [
  billfoldModule.name,
  reportOrdersModule.name
]);

export default reportsModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/reports/reports.js
 **/